function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count;
      const badge = document.querySelector('#cart-count');

      if (badge) {
        badge.textContent = cartCount;

        if (cartCount > 0) {
          badge.classList.add('active');
        } else {
          badge.classList.remove('active');
        }
      }
    })
    .catch(err => console.error("Cart count update failed:", err));
}

/* LISTEN TO ALL SHOPIFY AJAX CART EVENTS */
document.addEventListener('cart:refresh', updateCartCount);
document.addEventListener('cart:updated', updateCartCount);

/* LISTEN TO ADD TO CART EVENTS */
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-submit-add-to-cart]') ||
      e.target.closest('.product-quick-add--button')) {

    // Delay for Shopify add-to-cart event to complete
    setTimeout(updateCartCount, 300);
  }
});

/* LISTEN TO QTY CHANGE EVENTS IN CART DRAWER */
document.addEventListener('change', (e) => {
  if (e.target.name === 'updates[]') {
    setTimeout(updateCartCount, 300);
  }
});
